import {
    TOUR_DRAWER,
    STOP_LIST_DRAWER,
    STOP_DESCRIPTION_DRAWER,
    LIBRARY_DRAWER,
    MAP_DRAWER,
    HIDE_DRAWER,
    STOP_FADER_DRAWER,
    VR_INSTRUCTION_DRAWER,
} from './drawerMenuActions'
import { Map } from 'immutable'

const INITIAL_STATE = Map({
    name: HIDE_DRAWER,
    y: -1,
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case STOP_FADER_DRAWER:
        case TOUR_DRAWER:
        case STOP_LIST_DRAWER:
        case STOP_DESCRIPTION_DRAWER:
        case LIBRARY_DRAWER:
        case MAP_DRAWER:
        case HIDE_DRAWER:
        case VR_INSTRUCTION_DRAWER:
            return state.set('name', action.type).set('y', action.y || state.get('y'))
        default:
            return state
    }
}
